import Tabbar from "../../component/tabar";
// import { useNavigate } from "react-router-dom";
import HomeFilm from "../../component/HomeFilm/index";
import CinematicFilm from "../../component/HomeFilm/cinematic";
import Film from "../../component/HomeFilm/film";
import NewFilm from "../../component/HomeFilm/newfilm";
import AnimeShowcase from "../../component/AnimeShowcase/index";
import SieuNhan from "../../component/HomeFilm/tokusatsu";
import HighRateFilm from "../../component/HomeFilm/highRate";
import KoreaFilms from "../../component/HomeFilm/koreaFilm";
import ChinaFilms from "../../component/HomeFilm/chinaFilm";
import GenreCarousel from "../../component/Carousel/genreCarousel";
import HomeMusic from "../../component/HomeMusic/index";
import China3dFilms from "../../component/HomeFilm/china3dFilm";
import MovieRow from "../../component/MovieRow/index";

import TopList from "../../component/TopList/index";
import LatestComments from "../../component/LatestComments/index";
import AnnouncementBar from "../../component/Marquee/AnnouncementBar";
import { Helmet } from "react-helmet-async";
import LazySection from "../../component/LazySection/index";
import "./style.scss";

function Home() {
  // const navigate = useNavigate();

  // const handleAppClick = () => {
  //   navigate("/using-app");
  // };
  // const handleIosClick = () => {
  //   navigate("/using-app-ios");
  // };
  return (
    <>
      <Helmet>
        <title>
          Tecede - Xem phim miễn phí, Vietsub HD, Anime, Phim mới cập nhật
        </title>

        <meta
          name="description"
          content="Xem phim miễn phí chất lượng cao tại Tecede. Cập nhật phim mới mỗi ngày: phim lẻ, phim bộ, anime, phim Hàn, Trung Quốc, 3D, vietsub đầy đủ."
        />

        <meta
          name="keywords"
          content="xem phim miễn phí, phim vietsub, phim hd, anime, phim hàn quốc, phim trung quốc, phim mới, tecede"
        />

        {/* Open Graph (share Facebook) */}
        <meta property="og:title" content="Tecede - Xem phim miễn phí HD" />

        <meta
          property="og:description"
          content="Kho phim miễn phí chất lượng cao, cập nhật liên tục mỗi ngày."
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />

        {/* nếu có logo thì thêm */}
        <meta property="og:image" content="../../../public/home-image.png" />
      </Helmet>

      <div className="Home">
        {/* tabbar */}
        <div className="tabbar-container">
          <Tabbar />
        </div>
        {/* main */}
        <div className="Home__main">
          <AnnouncementBar />
          <div className="Home__music">
            <MovieRow />
          </div>

          <GenreCarousel />
          <LazySection>
            <LatestComments />
          </LazySection>
          <LazySection>
            <TopList />
          </LazySection>
          <LazySection>
            <HighRateFilm />
          </LazySection>
          <LazySection>
            <KoreaFilms />
          </LazySection>

          <LazySection>
            <ChinaFilms />
          </LazySection>

          {/* <div className="Home__music"> 
                <PopularFilm />
              </div> */}

          <LazySection>
            <China3dFilms />
          </LazySection>

          {/* <div className="Home__music"> 
                <MovieCarousel />
              </div> */}
          <LazySection>
            <Film />
          </LazySection>

          {/* <LazySection> 
                <NewAnimes />
              </LazySection> */}
          <LazySection>
            <AnimeShowcase />
          </LazySection>
          <LazySection>
            <NewFilm />
          </LazySection>
          <LazySection>
            <HomeFilm />
          </LazySection>
          <LazySection>
            <CinematicFilm />
          </LazySection>
          <LazySection>
            <SieuNhan />
          </LazySection>
          <LazySection>
            <HomeMusic />
          </LazySection>
        </div>
      </div>
    </>
  );
}

export default Home;
